// assets/soldout-label.js
(function () {
  function readMap(root) {
    var id = 'variant-soldout-labels-' + root.dataset.sectionId;
    var el = root.querySelector('#' + id);
    if (!el || !el.textContent) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function computeLabel(variant, btn, map) {
    var productLabel = btn.getAttribute('data-product-soldout') || '';
    var defaultLabel = btn.getAttribute('data-default-soldout') || 'Sold out';
    if (!variant) return defaultLabel;
    if (variant.available === false) {
      return (map[String(variant.id)] || productLabel || defaultLabel);
    }
    return btn.getAttribute('data-add-to-cart') || 'Add to cart';
  }

  function getVariantFromForm(root) {
    // Dawnはhidden input[name="id"]に現在のvariant.idを入れている
    var idEl = root.querySelector('input.product-variant-id');
    var vid = idEl && idEl.value;
    if (!vid) return null;

    // product JSONが無い場合は在庫判定をボタンdisabledで代用
    var btn = root.querySelector('#ProductSubmitButton-' + root.dataset.sectionId);
    var available = !(btn && btn.hasAttribute('disabled'));
    return { id: Number(vid), available: available };
  }

  function updateButton(root) {
    if (!root || !root.dataset || !root.dataset.sectionId) return;

    var btn = root.querySelector('#ProductSubmitButton-' + root.dataset.sectionId);
    if (!btn) return;
    var span = btn.querySelector('span');
    if (!span) return;

    var map = readMap(root);
    var variant = (root.__lastVariantObj) || getVariantFromForm(root);
    var label = computeLabel(variant, btn, map);
    if (span.textContent !== label) span.textContent = label;
  }

  function bindObserver(root) {
    if (!root || root.__soldoutObserverBound) return;
    var btn = root.querySelector('#ProductSubmitButton-' + root.dataset.sectionId);
    if (!btn) return;
    var span = btn.querySelector('span');
    if (!span) return;

    // 他スクリプトによる書き換えを常時監視し、最終的に上書き
    var mo = new MutationObserver(function () {
      // 少し遅らせて「相手が書き換え終わった後」に上書き
      requestAnimationFrame(function(){ updateButton(root); });
    });
    mo.observe(span, { childList: true, subtree: true, characterData: true });
    root.__soldoutObserverBound = true;
  }

  function handleVariantEvent(e) {
    var detail = e.detail || {};
    var variant = detail.variant || null;

    // 対象product-form（セクション）を特定
    var root = (e.target && e.target.closest && e.target.closest('product-form')) || null;
    if (!root) {
      // 見つからない場合は全てのproduct-formに適用（安全策）
      document.querySelectorAll('product-form[data-section-id]').forEach(function (pf) {
        pf.__lastVariantObj = variant;
        bindObserver(pf);
        // 相手の処理が終わった直後に上書き
        setTimeout(function(){ updateButton(pf); }, 0);
      });
      return;
    }

    root.__lastVariantObj = variant;
    bindObserver(root);
    setTimeout(function(){ updateButton(root); }, 0);
  }

  function initIn(container) {
    container.querySelectorAll('product-form[data-section-id]').forEach(function (pf) {
      bindObserver(pf);
      // 初期表示も正しく
      setTimeout(function(){ updateButton(pf); }, 0);
    });
  }

  // 初期化
  document.addEventListener('DOMContentLoaded', function(){ initIn(document); });
  document.addEventListener('shopify:section:load', function(e){ initIn(e.target || document); });

  // Dawnのイベント（新旧両対応）
  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('variant-change', handleVariantEvent);
})();